// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b48104b7","732":"a379e58d","952":"f30a0158","977":"8513688e"}[chunkId] + ".chunk.js";
};